import Contact from './contact';
import CreateContact from './create-contact';

export {
  Contact,
  CreateContact,
}



// WEBPACK FOOTER //
// ./src/browser/components/client/contacts/index.js